import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-button-hover]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-button-hover]').forEach((btn) => {
    /**
     *
     * btn is used over button element
     * btnOnLink is used over link element
     * dynamicContainer when button is inside a container that changes position dinamically
     * background-size (bgSize) is calculated based on its width
     */
    const btnOnLink = btn.querySelector('[data-au-button-hover-link]'),
      dynamicContainer = btn.closest('.swiper, [data-dynamic-container]');
    let elem = btnOnLink ? btnOnLink : btn,
      bgSize;

    if (!bgSize) {
      document.addEventListener('mouseover', (e) => {
        let bgSize = btn.clientWidth * 2;
        const target = e.target.closest('[data-au-button-hover]');

        if (target) {
          elem = btnOnLink ? btnOnLink : btn;
          bgSize = btn.clientWidth * 2;
          showCircleAroundCursor(btn, elem, bgSize, dynamicContainer);
        }
      });

      return;
    }

    btn.addEventListener('mouseover', () => showCircleAroundCursor(btn, elem, bgSize, dynamicContainer));
  });
}

function showCircleAroundCursor(btn, elem, bgSize, insideDynamicContainer) {
  const rectLeft = insideDynamicContainer ? btn.getBoundingClientRect().left : 0,
    rectTop = insideDynamicContainer ? btn.getBoundingClientRect().top : 0;

  btn.onmousemove = (e) => {
    elem.style.setProperty('--buttonHoverAfterBgSize', `${bgSize}px ${bgSize}px`);
    elem.style.setProperty(
      'background-position',
      `${e.clientX - rectLeft - bgSize / 2}px ${e.clientY - rectTop - bgSize / 2}px`,
    );
  };
}

export default { init };
